import { siteName } from '@/mocks/chigua';

const FOOT_LINKS: { title: string; items: { label: string; href: string }[] }[] = [
  {
    title: '快速浏览',
    items: [
      { label: '今日速览', href: '#ts' },
      { label: '全网热榜', href: '#rank' },
      { label: '栏目导航', href: '#lanmu' },
      { label: '话题广场', href: '#huati' },
    ],
  },
  {
    title: '更多内容',
    items: [
      { label: '专题深读', href: '#zhuanti' },
      { label: '关于我们', href: '#about' },
      { label: '常见问题', href: '#faq' },
      { label: '投稿爆料', href: '#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-secondary-200 bg-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          {/* brand */}
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="heading-font text-lg font-extrabold tracking-wide text-foreground-950">
                  {siteName}
                </span>
                <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">全网热点 · 一条线看尽</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              把今日热点、娱乐八卦与全网爆点按时间聚成一条信息流，附实时热榜与专题深读。顺着看，就知道今天全网正在聊什么。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-douban-line', 'ri-youtube-line', 'ri-rss-line'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交主页"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {FOOT_LINKS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="heading-font text-sm font-bold text-foreground-900">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.items.map((it) => (
                  <li key={it.label}>
                    <a
                      href={it.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteName} · 本页内容为示例演示，仅作站内信息展示
          </p>
          <p className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
            <a href="#about" className="transition-colors hover:text-primary-600">内容原则</a>
            <span className="text-secondary-300">·</span>
            <a href="#faq" className="transition-colors hover:text-primary-600">帮助中心</a>
            <span className="text-secondary-300">·</span>
            <a href="#contact" className="transition-colors hover:text-primary-600">意见反馈</a>
          </p>
        </div>
      </div>
    </footer>
  );
}